import { useAddSpaceModal } from "@circle-react/components/Modals/AddSpaceModal";
import { useNewSpaceGroupModal } from "@circle-react/components/Modals/NewSpaceGroupModal";
import { BlockInViewOnlyMode } from "@circle-react/components/ViewOnlyMasquerading/BlockInViewOnlyMode";
import { IconButton } from "@circleco/compass/components/IconButton";
import { Menu } from "@circleco/compass/components/Menu";

import { t } from "@/i18n-js/instance";

import type { SpaceGroupWithSpaces } from "../../Sidebar";

export interface AddMenuProps {
  canCreateSpace: boolean;
  isAdmin: boolean;
  onOpenChange: (isOpen: boolean) => void;
  position: number;
  spaceGroup: SpaceGroupWithSpaces;
}

export const AddMenu = ({
  canCreateSpace,
  isAdmin,
  onOpenChange,
  position,
  spaceGroup,
}: AddMenuProps) => {
  const spaceModal = useAddSpaceModal();
  const spaceGroupModal = useNewSpaceGroupModal();

  const handleCreateSpace = () => {
    void spaceModal.show({ spaceGroupId: spaceGroup.id });
  };

  const handleCreateSpaceGroup = () => {
    void spaceGroupModal.show({ position });
  };

  const options = [
    ...(canCreateSpace
      ? [
          {
            label: t("add_space"),
            onClick: handleCreateSpace,
          },
        ]
      : []),
    ...(isAdmin
      ? [
          {
            label: t("add_space_group"),
            onClick: handleCreateSpaceGroup,
          },
        ]
      : []),
  ];

  return (
    <BlockInViewOnlyMode>
      <Menu
        options={options}
        align="start"
        onOpenChange={onOpenChange}
        trigger={
          <IconButton
            aria-label={t("community_sidebar.add_space_or_space_group")}
            data-testid="spacegroup-add-button"
            icon="plus"
            size="sm"
            type="button"
            variant="ghost"
          />
        }
      />
    </BlockInViewOnlyMode>
  );
};
